import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const KEY = "velyrea_cookie_consent";
const DEFAULT = { necessary: true, analytics: false, advertising: false, decided: false };

const ConsentContext = createContext(null);

export function ConsentProvider({ children }) {
  const [prefs, setPrefs] = useState(() => {
    try { return { ...DEFAULT, ...(JSON.parse(localStorage.getItem(KEY)) || {}) }; } catch (e) { console.warn("Consent read failed:", e); return DEFAULT; }
  });
  const [managerOpen, setManagerOpen] = useState(false);

  // Activate/deactivate analytics (PostHog) based on consent
  useEffect(() => {
    if (typeof window === "undefined" || !window.posthog) return;
    try {
      if (prefs.decided && prefs.analytics) window.posthog.opt_in_capturing();
      else window.posthog.opt_out_capturing();
    } catch (e) { console.warn("PostHog consent sync skipped:", e); }
  }, [prefs.decided, prefs.analytics]);

  const persist = useCallback((next) => {
    const val = { ...next, necessary: true, decided: true };
    localStorage.setItem(KEY, JSON.stringify(val));
    setPrefs(val);
    setManagerOpen(false);
  }, []);

  const acceptAll = useCallback(() => persist({ analytics: true, advertising: true }), [persist]);
  const rejectAll = useCallback(() => persist({ analytics: false, advertising: false }), [persist]);
  const savePrefs = useCallback((p) => persist(p), [persist]);
  const openManager = useCallback(() => setManagerOpen(true), []);

  return (
    <ConsentContext.Provider value={{ prefs, acceptAll, rejectAll, savePrefs, openManager, managerOpen, setManagerOpen }}>
      {children}
    </ConsentContext.Provider>
  );
}

export const useConsent = () => useContext(ConsentContext);
